import { render, staticRenderFns } from "./huodeLive.vue?vue&type=template&id=2cf3fa79&scoped=true"
import script from "./huodeLive.vue?vue&type=script&lang=js"
export * from "./huodeLive.vue?vue&type=script&lang=js"
import style0 from "./huodeLive.vue?vue&type=style&index=0&id=2cf3fa79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf3fa79",
  null
  
)

export default component.exports